<mat-card class="org-details-card" *ngIf="organization">
    <mat-card-title>Organization Details</mat-card-title>
    <mat-divider></mat-divider>
    <br>
    <mat-card-content>
      <div class="org-grid">
        <div><strong>Name:</strong> {{ organization.org_name }}</div>
        <div><strong>Type:</strong> {{ organization.org_type }}</div>
        <div><strong>Registration #:</strong> {{ organization.registration_number }}</div>
        <div><strong>GST #:</strong> {{ organization.gst_number || 'N/A' }}</div>
        <div><strong>PAN #:</strong> {{ organization.pan_number || 'N/A' }}</div>
        <div><strong>Address:</strong> {{ organization.address || 'N/A' }}</div>
        <div><strong>City:</strong> {{ organization.city }}</div>
        <div><strong>State:</strong> {{ organization.state }}</div>
        <div><strong>Postal Code:</strong> {{ organization.postal_code }}</div>
        <div><strong>Country:</strong> {{ organization.country }}</div>
        <div><strong>Contact Name:</strong> {{ organization.primary_contact_name }}</div>
        <div><strong>Contact Email:</strong> {{ organization.primary_contact_email }}</div>
        <div><strong>Contact Phone:</strong> {{ organization.primary_contact_phone }}</div>
        <div><strong>Onboarding Date:</strong> {{ organization.onboarding_date | date }}</div>
        <div><strong>Status:</strong> {{ organization.status === 'true' ? 'Active' : 'Inactive' }}</div>
        <div><strong>Rating:</strong> {{ organization.rating || 'Not Rated' }}</div>
      </div>
    </mat-card-content>
  </mat-card>
  